module.exports = __webpack_public_path__ + "08b6b451e5bfc23fef59916a7f31a920.png";